import services from '@/api/services';
import StoreConstructor from '@/store/core/StoreConstructor';
import { action, observable } from 'mobx';

export default class ExternalTaxPayersStore extends StoreConstructor {
  @observable isFetching = false;
  @observable registrationData: any = null;
  @observable registrationError: any = null;
  @observable statusData: any = null;
  @observable errorText: null | string = null;

  @action async sendRegistrationRequest(
    body: any,
    successCallback: () => void,
  ) {
    this.isFetching = true;
    try {
      const { data } = await services.external.postRegistrationRequest(body);
      this.registrationData = data;
      if (data && data.id) {
        this.registrationError = null;
        setTimeout(() => {
          this.getRegistrationStatusRequest(data.id, successCallback);
        }, 2000);
      }
    } catch (e: any) {
      console.error(e);
      this.registrationError = e?.response?.data?.message;
    } finally {
      this.isFetching = false;
    }
  }

  @action async getRegistrationStatusRequest(
    id: string,
    successCallback: () => void,
  ) {
    this.isFetching = true;
    try {
      const { data } = await services.external.getRegistrationStatusRequest(id);
      this.statusData = data;
      if (data && data.status === 'FAILED') {
        this.errorText = data.rejectCode;
      } else if (data && data.status === 'PENDING') {
        setTimeout(() => {
          this.getRegistrationStatusRequest(id, successCallback);
        }, 2000);
      } else {
        successCallback();
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }

  @action reset() {
    this.registrationData = null;
    this.registrationError = null;
    this.statusData = null;
    this.errorText = null;
  }
}
